// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__tlQKh","text":"loading_text__Dg3IY"};